import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AlertMessageModule, FooterModule, HubNavModule } from '@toro/common/shared/components';

import { CustomerWalletModule } from './customer-wallet.module';
import { CustomerWalletDetailsComponent } from './pages/details/customer-wallet-details.component';
import { GuidedTourModule } from "ngx-guided-tour";

@NgModule({
    declarations: [
        CustomerWalletDetailsComponent,
    ],
    imports: [
        CommonModule,
        HubNavModule,
        FooterModule,
        CustomerWalletModule,
        RouterModule.forChild([
            {
                path: 'alocacao',
                component: CustomerWalletDetailsComponent
            },
        ]),
        GuidedTourModule,
        AlertMessageModule
    ]
})
export class CustomerWalletRoutesModule {}
